// extracted by mini-css-extract-plugin
module.exports = {"blockquote":"blockquote-module--blockquote--2-JMW","fontsLoading":"blockquote-module--fonts-loading--3OgaU","blockquoteLink":"blockquote-module--blockquoteLink--3zI8V"};